import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import SingleDatePicker from 'components/SingleDatePicker';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceDateField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    testId = TEST_ID,
    value
}) => {
    const t = useTranslation();

    const handleChange = (date: Date | undefined) => onChange({ date });

    return (
        <VerticalContainer className={`${styles.serviceDateField} ${className}`} testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_DATE}</Wrapper>

            <SingleDatePicker className={styles.datePicker} onChange={handleChange} value={value} />
        </VerticalContainer>
    );
};

export default ServiceDateField;
